(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7140],{

/***/ 5317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96781);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10682);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


 // import CustomIframe from './CustomIframe';





function Tally(_ref) {
  var masterConfig = _ref.masterConfig,
      showExitTally = _ref.showExitTally,
      showResultTally = _ref.showResultTally,
      stateName = _ref.stateName;
  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_1__/* .useWindowSize */ .iP)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [showExitTally != false && (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL, "&state_name=").concat(stateName),
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exitpolltally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "result-page  ",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
            style: {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
              scrolling: "no",
              src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL, "&state_name=").concat(stateName),
              width: "100%",
              height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exitpolltally_height_web
            })
          })]
        })
      })
    }), showResultTally != false && (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL, "&state_name=").concat(stateName),
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "result-page-big",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
            style: {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
              scrolling: "no",
              src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL, "&state_name=").concat(stateName),
              width: "100%",
              height: size.width != 768 && size.width <= 1000 ? masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_tab_internal : masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_web // height={(size.width != 768 && size.width <= 1000 )? masterConfig.Maharashtra_Resulttally_height_tab_internal   :
              //   masterConfig
              //     .Maharashtra_Resulttally_height_web
              // }
              // height={(window.innerWidth != 768 && window.innerWidth <= 1000) ? masterConfig?.Maharashtra_Resulttally_height_tab_internal :  masterConfig?.Maharashtra_Resulttally_height_web}

            })
          })]
        })
      })
    }), (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally_URL,
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Bypoll_Resulttally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally_URL,
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Bypoll_Resulttally_height_web
          })
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (Tally);

/***/ }),

/***/ 7725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



// import Link from "next/link";
var NotFound = function NotFound() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
    className: "container",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: "page-not-found",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        children: "\u0915\u094D\u0937\u092E\u093E \u0915\u0930\u0947\u0902"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        children: "\u0906\u092A\u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0905\u0928\u0941\u0930\u094B\u0927 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u092A\u0947\u091C \u0909\u092A\u0932\u092C\u094D\u200D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
        children: ["\u0939\u094B\u092E \u092A\u0947\u091C \u092A\u0930 \u091C\u093E\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092F\u0939\u093E\u0902 ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
          href: "/",
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: "\u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902"
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NotFound);

/***/ }),

/***/ 5544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/MasterConfigContext.js
var MasterConfigContext = __webpack_require__(39712);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/api/commonConstants.js
var commonConstants = __webpack_require__(96781);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./src/api/constants.js
var constants = __webpack_require__(9041);
// EXTERNAL MODULE: ./src/components/tally/Tally.jsx
var Tally = __webpack_require__(5317);
// EXTERNAL MODULE: ./src/constants/state.js
var state = __webpack_require__(25613);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/vidhansabha/KeyCandidatesD.js
















var StateKeyCandidateD = function StateKeyCandidateD(_ref) {
  var _electionTopicData$, _electionTopicData$2, _electionTopicData$3, _electionTopicData$4, _electionTopicData$5, _electionTopicData$6, _electionTopicData$7, _electionTopicData$8;

  var keyCandidatesData = _ref.keyCandidatesData,
      breadCrump = _ref.breadCrump,
      stateName = _ref.stateName,
      stateNameHi = _ref.stateNameHi,
      propData = _ref.propData,
      masterKey = _ref.masterKey,
      electionState = _ref.electionState;
  // const [keyCandidatesData, setKeyCandidatesData] = useState([]);
  var masterConfig = (0,react.useContext)(MasterConfigContext/* MasterConfigContext */.d);
  var electionKeys = masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.vidhansabha_election;
  var DEFAULT_IMAGE = 'https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/default-partylogo.jpg'; //old data 
  // const electionsData = masterConfig;
  // electionsData

  var electionsData = masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig[masterKey];
  var showKeyCand = true;
  var size = (0,commonConstants/* useWindowSize */.iP)();
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      electionTopicData = _useState[0],
      setElectionTopicData = _useState[1];

  (0,react.useEffect)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _dataFetched, _dataFetched$result;

    var dataFetched, datas;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(constants/* baseUrl */.FH, "/web/postListByCategory/election?limit=5&skip=1&type=text,video,liveblog"));

          case 2:
            datas = _context.sent;
            _context.next = 5;
            return datas === null || datas === void 0 ? void 0 : datas.json();

          case 5:
            dataFetched = _context.sent;
            dataFetched = (_dataFetched = dataFetched) === null || _dataFetched === void 0 ? void 0 : (_dataFetched$result = _dataFetched.result) === null || _dataFetched$result === void 0 ? void 0 : _dataFetched$result.entities;
            setElectionTopicData(dataFetched);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);

  var getKeyCandidatesData = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var response, data1, tempData, keyCandidates;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return fetch(propData.dataUrl);

            case 3:
              response = _context2.sent;
              _context2.next = 6;
              return response.json();

            case 6:
              data1 = _context2.sent;
              tempData = data1 === null || data1 === void 0 ? void 0 : data1.data["ALL KEY CANDIDATES"]; // if (stateName === "Jammu and Kashmir") {
              //   let keyCandidates = tempData?.filter(
              //     (con) => con?.STATE == "Jammu and Kashmir"
              //   );
              //   setKeyCandidatesData(keyCandidates);
              // } else {
              //   let keyCandidates = tempData?.filter((con) => con?.STATE == "Haryana");
              //   setKeyCandidatesData(keyCandidates);
              // }

              keyCandidates = tempData === null || tempData === void 0 ? void 0 : tempData.filter(function (con) {
                return (con === null || con === void 0 ? void 0 : con.STATE) == (propData === null || propData === void 0 ? void 0 : propData.dataKey);
              });
              setKeyCandidatesData(keyCandidates);
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              console.error("Error fetching data: ", _context2.t0);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 12]]);
    }));

    return function getKeyCandidatesData() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    setTimeout(function () {
      window.googletag = window.googletag || {
        cmd: []
      };

      if (window.screen.width > 600) {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_1_728x90", [728, 90], "div-gpt-ad-1701945220410-1").addService(googletag.pubads()); //  googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());

          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      } else {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_1_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-1").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Mobile_HP_Bottom_320x50", [320, 50], "div-gpt-ad-1701946324333-0").addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      }

      googletag.pubads().refresh(); // console.log("apstag", typeof apstag);
      // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [
      //       ],
      //     },
      //     function (bids) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500);
  }, []); // useEffect(() => {
  //   getKeyCandidatesData();
  // }, []);

  console.log("All Data ", keyCandidatesData);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "http://schema.org/",
            "@type": "WebPage",
            name: "".concat(stateName, " Assembly Election ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, " Key-Candidate List: ").concat(stateNameHi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, " \u0915\u0947 \u092E\u0941\u0916\u094D\u092F-\u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930 \u0915\u0940 \u0938\u0942\u091A\u0940"),
            description: "".concat(stateName, " Assembly Election Key-Candidate List:  Check here latest upadtes of ").concat(stateNameHi, " \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935. Key-candiadate list of parties"),
            keywords: " ".concat(stateName, " Assembly Election Key-Candidate List\n                                ").concat(stateName, " Assembly Chunav ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, " Key-Candidate List\n                                ").concat(stateName, " Assembly Election ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, "\n                                \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, "\n                                ").concat(stateNameHi, " \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935  ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, "\n                                ").concat(stateNameHi, " \u091A\u0941\u0928\u093E\u0935 \u092E\u0941\u0916\u094D\u092F-\u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930 \u0938\u0942\u091A\u0940\n                                ").concat(stateName, " Election ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, "\n                                ").concat(stateNameHi, " \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u092E\u0941\u0916\u094D\u092F-\u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930"),
            url: "".concat("https://www.thelallantop.com").concat(router.asPath),
            publisher: {
              "@type": "Organization",
              name: "The Lallantop",
              url: "https://www.thelallantop.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                width: 600,
                height: 60
              }
            }
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [{
              "@type": "ListItem",
              position: 1,
              item: {
                "@id": "".concat("https://www.thelallantop.com/"),
                name: "Home"
              }
            }, {
              "@type": "ListItem",
              position: 2,
              item: {
                name: "".concat(stateName, " Assembly Chunav"),
                "@id": "".concat("https://www.thelallantop.com/", "election/").concat(electionState)
              }
            }, {
              "@type": "ListItem",
              position: 3,
              item: {
                name: "".concat(stateName, " Key Candidates"),
                "@id": "".concat("https://www.thelallantop.com/", "election/").concat(electionState, "/key-candidates")
              }
            }]
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SiteNavigationElement",
            name: ["होम", "चुनाव", "न्यूज़", "एंटरटेनमेंट", "ऑडनारी", "टेक्नोलॉजी", "पड़ताल", "बिज़नेस", "लल्लनख़ास", "स्पोर्ट्स", "रंगरूट"],
            url: ["https://www.thelallantop.com/", "https://www.thelallantop.com/election", "https://www.thelallantop.com/news", "https://www.thelallantop.com/entertainment", "https://www.thelallantop.com/oddnaari", "https://www.thelallantop.com/technology", "https://www.thelallantop.com/factcheck", "https://www.thelallantop.com/business", "https://www.thelallantop.com/lallankhas", "https://www.thelallantop.com/sports", "https://www.thelallantop.com/education"]
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        crossOrigin: "true",
        href: "https://static.chartbeat.com"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        async: true,
        dangerouslySetInnerHTML: {
          __html: "\n            (function () {\n              var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});\n              _sf_async_config.uid = 60355;\n              _sf_async_config.domain = 'thelallantop.com';\n              _sf_async_config.useCanonical = true;\n              _sf_async_config.useCanonicalDomain = true;\n              _sf_async_config.sections = 'home'; \n              _sf_async_config.authors = '';\n              function loadChartbeat() {\n                  var e = document.createElement('script');\n                  var n = document.getElementsByTagName('script')[0];\n                  e.type = 'text/javascript';\n                  e.async = true;\n                  e.src = '//static.chartbeat.com/js/chartbeat.js';\n                  n.parentNode.insertBefore(e, n);\n              }\n              loadChartbeat();\n          })();\n       "
        },
        strategy: "afterInteractive",
        id: "chartbeat",
        type: "text/javascript"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "".concat(stateName, " Assembly Election ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, " Key-Candidate List: ").concat(stateNameHi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, " \u0915\u0947 \u092E\u0941\u0916\u094D\u092F-\u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930 \u0915\u0940 \u0938\u0942\u091A\u0940"),
      description: "".concat(stateName, " Assembly Election Key-Candidate List:  Check here latest upadtes of ").concat(stateNameHi, " \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935. Key-candiadate list of parties"),
      canonical: "".concat("https://www.thelallantop.com").concat(router.asPath)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: "".concat(stateName, " Assembly Election Key-Candidate List\n        ").concat(stateName, " Assembly Chunav ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, " Key-Candidate List\n        ").concat(stateName, " Assembly Election ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, "\n        \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, "\n        ").concat(stateNameHi, " \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935  ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, "\n        ").concat(stateNameHi, " \u091A\u0941\u0928\u093E\u0935 \u092E\u0941\u0916\u094D\u092F-\u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930 \u0938\u0942\u091A\u0940\n        ").concat(stateName, " Election ").concat(electionsData === null || electionsData === void 0 ? void 0 : electionsData.displayYear, "\n        ").concat(stateNameHi, " \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u092E\u0941\u0916\u094D\u092F-\u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930")
    }), size.width > 600 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: size.width >= 600 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          position: "relative",
          display: "flex",
          justifyContent: "center"
        },
        children: [router.asPath.includes("election") && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            position: "relative"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/election-background-3.png",
            style: {
              position: "relative",
              width: "100%",
              height: "298px"
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/left-election-top-2.png",
            width: "",
            height: "170px",
            style: {
              position: "absolute",
              bottom: "10px",
              left: "10px"
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: router.asPath.includes("haryana-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
            width: "",
            height: "250px",
            style: {
              position: "absolute",
              bottom: "0",
              right: "0px"
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
          align: "center",
          style: {
            position: router.asPath.includes("/election") ? "absolute" : "relative",
            top: router.asPath.includes("/election") ? "22px" : "0px"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "container-row py-2",
            align: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              style: {
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
                marginBottom: "0px"
              },
              children: "Advertisement"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "div-gpt-ad-1701945163318-0",
              style: {
                minWidth: "300px",
                minHeight: "100px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center"
              },
              className: "ads-auto-resize",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                  __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})"
                }
              })
            })]
          })
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          position: "relative",
          width: "100%"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/assets/images/election-background-mobile.png",
          style: {
            position: "relative",
            width: "100%",
            height: "auto"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/assets/images/election-left-mobile.png",
          width: "",
          height: "70px",
          style: {
            position: "absolute",
            bottom: "10px",
            left: "10px"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: router.asPath.includes("haryana-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
          width: "",
          height: "90px",
          style: {
            position: "absolute",
            bottom: "0",
            right: "0px"
          }
        })]
      })
    }), size.width > 768 ?
    /*#__PURE__*/
    //breadcrump for desktop
    (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          width: "auto",
          margin: "auto",
          gap: "20px",
          minHeight: "80px",
          marginTop: "15px",
          borderRadius: "12px",
          padding: "0px 30px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            // paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            backgroundColor: "white",
            paddingLeft: "0px"
          } // onClick={() =>
          //   window.open("/election/lok-sabha-chunav-${electionsData?.displayYear}", "_self")
          // }
          ,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "408.56px",
            height: "58.21px",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "0px 0px",
            // backgroundColor: "rgb(217, 54, 139)",
            paddingLeft: "15px",
            alignContent: "center"
          },
          children: breadCrump.length > 0 && breadCrump.map(function (item, index) {
            return electionsData[item.keyToShow] != false ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          })
        })]
      })
    }) :
    /*#__PURE__*/
    //breadcrump for mobile
    (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            paddingBottom: "1rem",
            backgroundColor: "white",
            marginTop: "10px"
          } // onClick={() =>
          //   window.open("/election/lok-sabha-chunav-${electionsData?.displayYear}", "_self")
          // }
          ,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "240px",
            height: "auto",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "-1px 0px",
            backgroundColor: "white",
            paddingLeft: "15px",
            paddingBottom: "1rem"
          },
          children: breadCrump.length > 0 && breadCrump.map(function (item, index) {
            return electionsData[item.keyToShow] != false ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), size.width <= 768 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container-row py-2",
      align: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          textAlign: "center",
          marginBottom: "0px"
        },
        children: "Advertisement"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "div-gpt-ad-1701946028239-0",
        style: {
          minWidth: "300px",
          minHeight: "260px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        className: "ads-auto-resize",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
          }
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tally/* default */.Z, {
      stateName: state/* stateData */.i[electionState].tallyState,
      masterConfig: electionsData
    }), showKeyCand ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "py-4 px-2 keycand-div",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "breadcrumb key-bread",
          style: {
            justifyContent: "space-between"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            style: {
              display: "flex"
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                  "aria-label": "Lallantop Home",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                    className: "icon-cat-home"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "Home"
                  })]
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "/election/".concat(electionState),
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  "aria-label": "Lallantop Home",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: [stateName, " Assembly Chunav"]
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Key Candidates"
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            background: "white",
            padding: size.width >= 768 ? "10px 30px" : "10px 8px"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex items-center h-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
              className: "font-bold font-devnagri text-2xl",
              children: [stateNameHi, " \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 ", propData['electionYear'], " \u0915\u0947 \u092E\u0941\u0916\u094D\u092F-\u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930 \u0915\u0940 \u0938\u0942\u091A\u0940"]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: propData.textPara
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            style: {
              marginTop: "20px",
              display: "flex",
              marginBottom: "16px",
              justifyContent: "space-between"
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                display: "flex",
                gap: "8px",
                marginBottom: "16px",
                width: size.width < 500 && "100%"
              },
              children: propData['tabs'].map(function (item, index) {
                return !(electionsData[item.keyToShow] == false) ?
                /*#__PURE__*/
                //  <div className="assembly-buttons width-m-50">
                (0,jsx_runtime.jsx)("div", {
                  onClick: function onClick() {
                    return window.location.href = item.url;
                  },
                  className: item.showActive ? "assembly-buttons-btn-active" : "assembly-buttons-btn",
                  children: item.text
                }, index) : null;
              })
            }), size.width >= 768 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              style: {
                display: "flex",
                gap: "20px",
                border: "2px solid rgb(128 128 128 / 46%)",
                borderRadius: "10px",
                width: "fit-content",
                padding: "10px 10px",
                fontWeight: "700",
                fontSize: "18px",
                height: "48px"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  height: "fit-content"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Lead"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  width: "18px",
                  height: "18px",
                  src: "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-up.png"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  height: "fit-content"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Trail"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  width: "18px",
                  height: "18px",
                  src: "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-down.png"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  height: "fit-content",
                  display: "flex"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Won"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  style: {
                    marginLeft: "5px",
                    marginTop: "2px"
                  },
                  width: "18px",
                  height: "18px",
                  src: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                style: {
                  height: "fit-content"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Lost"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  style: {
                    marginLeft: "5px"
                  },
                  width: "18px",
                  height: "18px",
                  src: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png"
                })]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              border: "2px solid #E2E2E2",
              borderTop: "6px solid #E2E2E2",
              marginTop: "15px"
            },
            children: keyCandidatesData && keyCandidatesData.length > 0 && (size.width >= 768 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                display: "flex",
                flexWrap: "wrap"
              },
              children: keyCandidatesData.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    width: "50%",
                    padding: "10px"
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    style: {
                      backgroundColor: "#F7F9FA",
                      padding: "5px 10px",
                      display: "flex"
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      style: {
                        width: "7%"
                      },
                      children: (item === null || item === void 0 ? void 0 : item.STATUS) != "" && (electionsData === null || electionsData === void 0 ? void 0 : electionsData.keyCandidate_Win_Loss_Logo) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: (item === null || item === void 0 ? void 0 : item.STATUS) == "WON" ? "https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png" : (item === null || item === void 0 ? void 0 : item.STATUS) == "LOST" ? "https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png" : (item === null || item === void 0 ? void 0 : item.STATUS) == "TRAILING" ? "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-down.png" : "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-up.png",
                        alt: item === null || item === void 0 ? void 0 : item.CANDIDATE_H,
                        style: {
                          width: "40px",
                          height: "40px",
                          objectFit: "none"
                        }
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      style: {
                        width: "20%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: item !== null && item !== void 0 && item.IMAGE ? item === null || item === void 0 ? void 0 : item.IMAGE : DEFAULT_IMAGE,
                        alt: item === null || item === void 0 ? void 0 : item.CANDIDATE_H,
                        style: {
                          borderRadius: "50%",
                          width: "40px",
                          height: "40px",
                          objectFit: "cover"
                        }
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      style: {
                        width: (item === null || item === void 0 ? void 0 : item.STATUS) == "" ? "65%" : "60%",
                        display: "flex",
                        alignItems: "center"
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        style: {
                          display: "flex",
                          flexDirection: "column"
                        },
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          onClick: function onClick() {
                            var _item$CANDIDATE;

                            electionsData.ShowProfileFromKC && (item === null || item === void 0 ? void 0 : item.CANDIDATE) != 'NOTA' ? window.open("".concat("https://www.thelallantop.com", "/election/").concat(electionState, "/candidate-").concat(item === null || item === void 0 ? void 0 : (_item$CANDIDATE = item.CANDIDATE) === null || _item$CANDIDATE === void 0 ? void 0 : _item$CANDIDATE.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-").concat(item === null || item === void 0 ? void 0 : item.CANDIDATE_ID, "-").concat(item === null || item === void 0 ? void 0 : item.CID), "_self") : "";
                          },
                          style: {
                            fontWeight: "700",
                            cursor: electionsData.ShowProfileFromKC ? "pointer" : "",
                            textDecoration: electionsData.ShowProfileFromKC ? "underline" : ""
                          },
                          children: item === null || item === void 0 ? void 0 : item.CANDIDATE_H
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                          style: {
                            color: "#808080"
                          },
                          children: [" ", "(", item === null || item === void 0 ? void 0 : item.CONSTITUENCY_H, ")"]
                        })]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      style: {
                        width: "15%",
                        textAlign: "Center"
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: item === null || item === void 0 ? void 0 : item.PARTY_LOGO,
                        alt: item === null || item === void 0 ? void 0 : item.PARTY_H,
                        style: {
                          borderRadius: "50%",
                          width: "25px",
                          height: "25px",
                          objectFit: "cover"
                        }
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: item === null || item === void 0 ? void 0 : item.PARTY_H
                      })]
                    })]
                  })
                }, index);
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column"
              },
              children: keyCandidatesData.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    width: "100%",
                    padding: "6px"
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    style: {
                      backgroundColor: "#F7F9FA",
                      padding: "5px 10px",
                      display: "flex",
                      gap: "4px"
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      style: {
                        width: "15%",
                        alignContent: "center"
                      },
                      children: (item === null || item === void 0 ? void 0 : item.STATUS) != "" && (electionsData === null || electionsData === void 0 ? void 0 : electionsData.keyCandidate_Win_Loss_Logo) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: (item === null || item === void 0 ? void 0 : item.STATUS) == "WON" ? "https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png" : (item === null || item === void 0 ? void 0 : item.STATUS) == "LOST" ? "https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png" : (item === null || item === void 0 ? void 0 : item.STATUS) == "TRAILING" ? "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-down.png" : "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-up.png",
                        alt: item === null || item === void 0 ? void 0 : item.CANDIDATE_H,
                        style: {
                          width: "40px",
                          height: "40px",
                          objectFit: "none"
                        }
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      style: {
                        width: "20%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: item !== null && item !== void 0 && item.IMAGE ? item === null || item === void 0 ? void 0 : item.IMAGE : DEFAULT_IMAGE,
                        alt: item === null || item === void 0 ? void 0 : item.CANDIDATE_H,
                        style: {
                          borderRadius: "50%",
                          width: "30px",
                          height: "30px",
                          objectFit: "cover"
                        }
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      style: {
                        width: (item === null || item === void 0 ? void 0 : item.STATUS) == "" ? "65%" : "53%",
                        display: "flex",
                        alignItems: "center"
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        style: {
                          display: "flex",
                          flexDirection: "column"
                        },
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          onClick: function onClick() {
                            var _item$CANDIDATE2;

                            electionsData.ShowProfileFromKC && (item === null || item === void 0 ? void 0 : item.CANDIDATE) != 'NOTA' ? window.open("".concat("https://www.thelallantop.com", "/election/").concat(electionState, "/candidate-").concat(item === null || item === void 0 ? void 0 : (_item$CANDIDATE2 = item.CANDIDATE) === null || _item$CANDIDATE2 === void 0 ? void 0 : _item$CANDIDATE2.toLowerCase().replace(/[^a-zA-Z ]/g, "").split(" ").join("-"), "-").concat(item === null || item === void 0 ? void 0 : item.CANDIDATE_ID, "-").concat(item === null || item === void 0 ? void 0 : item.CID), "_self") : "";
                          },
                          style: {
                            fontWeight: "700",
                            cursor: electionsData.ShowProfileFromKC ? "pointer" : "",
                            textDecoration: electionsData.ShowProfileFromKC ? "underline" : ""
                          },
                          children: item === null || item === void 0 ? void 0 : item.CANDIDATE_H
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                          style: {
                            color: "#808080"
                          },
                          children: [" ", "(", item === null || item === void 0 ? void 0 : item.CONSTITUENCY_H, ")"]
                        })]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      style: {
                        width: "15%",
                        alignContent: "center",
                        textAlign: "center"
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: item === null || item === void 0 ? void 0 : item.PARTY_LOGO,
                        alt: item === null || item === void 0 ? void 0 : item.PARTY_H,
                        style: {
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          objectFit: "cover"
                        }
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: item === null || item === void 0 ? void 0 : item.PARTY_H
                      })]
                    })]
                  })
                }, index);
              })
            }))
          }), size.width < 768 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            style: {
              display: "flex",
              gap: "20px",
              border: "2px solid rgb(128 128 128 / 46%)",
              borderRadius: "10px",
              width: "fit-content",
              padding: "10px 10px",
              margin: "auto",
              marginTop: "10px",
              fontWeight: "700",
              fontSize: "18px"
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Lead"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                width: "18px",
                height: "18px",
                src: "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-up.png"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Trail"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                width: "18px",
                height: "18px",
                src: "https://static-dev.indiatodayonline.in/lingo/nwtak/resources/arrow-down.png"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              style: {
                display: "flex"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Won"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                style: {
                  marginLeft: "5px"
                },
                width: "18px",
                height: "18px",
                src: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Lost"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                style: {
                  marginLeft: "5px"
                },
                width: "18px",
                height: "18px",
                src: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/lost.png"
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "electionYatra-outer-home",
        style: {
          width: "100% "
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "electionYatra-header",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/assets/images/election-icon.png",
              width: "35px",
              height: "35px",
              alt: "election-icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              style: {
                marginLeft: "10px",
                display: "inline-block"
              },
              children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "election-aurDekhe",
            onClick: function onClick() {
              return router.push("/election");
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: {
                marginRight: "10px"
              },
              children: "\u0914\u0930 \u0926\u0947\u0916\u0947\u0902 "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/assets/images/arrow.png",
              width: "10px",
              height: "10px"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "electionYatra-columns",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "checkMobileOrNot",
            href: "".concat((_electionTopicData$ = electionTopicData[0]) === null || _electionTopicData$ === void 0 ? void 0 : _electionTopicData$.permalink),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "electionYatra-second election-mobile",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "electionYatra-second-top",
                style: {
                  position: "relative"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: (_electionTopicData$2 = electionTopicData[0]) === null || _electionTopicData$2 === void 0 ? void 0 : _electionTopicData$2.headingImageUrl
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                  className: ((_electionTopicData$3 = electionTopicData[0]) === null || _electionTopicData$3 === void 0 ? void 0 : _electionTopicData$3.type) == 'video' ? "icon-play-circle" : 'icon-cat-read',
                  width: "500px",
                  height: "500px",
                  style: {
                    color: "white",
                    position: "absolute",
                    left: "2px",
                    bottom: "-5px",
                    width: "500px"
                  }
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "electionYatra-second-bottom",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: (_electionTopicData$4 = electionTopicData[0]) === null || _electionTopicData$4 === void 0 ? void 0 : _electionTopicData$4.title
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            },
            children: electionTopicData.slice(1).map(function (x, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "".concat(x === null || x === void 0 ? void 0 : x.permalink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "electionYatra-first",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "electionYatra-first-div",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      style: {
                        // flex: "0 0 38%",
                        position: "relative",
                        justifyContent: "center",
                        alignContent: "center",
                        alignItems: "center"
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: x === null || x === void 0 ? void 0 : x.headingImageUrl,
                        width: "160px",
                        height: "90px"
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                        className: (x === null || x === void 0 ? void 0 : x.type) == 'video' ? "icon-play-circle" : 'icon-cat-read',
                        style: {
                          color: "white",
                          position: "absolute",
                          left: "2px",
                          bottom: "-5px"
                        }
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "electionYatra-first-div-right",
                      style: {
                        flex: "0 0 60%"
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          style: {
                            overflow: "hidden"
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                            style: {
                              display: "-webkit-box",
                              lineHeight: "22px",
                              WebkitLineClamp: "3",
                              WebkitBoxOrient: "vertical",
                              marginTop: "5px"
                            },
                            className: "chunav-yatra-small-title",
                            children: x === null || x === void 0 ? void 0 : x.title
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        style: {
                          display: "flex",
                          gap: "1rem"
                        }
                      })]
                    })]
                  })
                })
              }, index);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            style: {
              width: "100%"
            },
            className: "checkDesktopOrNot",
            href: "".concat((_electionTopicData$5 = electionTopicData[0]) === null || _electionTopicData$5 === void 0 ? void 0 : _electionTopicData$5.permalink),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "electionYatra-second election-desktop",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "electionYatra-second-top",
                style: {
                  position: "relative"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: (_electionTopicData$6 = electionTopicData[0]) === null || _electionTopicData$6 === void 0 ? void 0 : _electionTopicData$6.headingImageUrl
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                  className: ((_electionTopicData$7 = electionTopicData[0]) === null || _electionTopicData$7 === void 0 ? void 0 : _electionTopicData$7.type) == 'video' ? "icon-play-circle" : 'icon-cat-read',
                  width: "500px",
                  height: "500px",
                  style: {
                    color: "white",
                    position: "absolute",
                    left: "2px",
                    bottom: "-5px",
                    width: "500px"
                  }
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "electionYatra-second-bottom",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: (_electionTopicData$8 = electionTopicData[0]) === null || _electionTopicData$8 === void 0 ? void 0 : _electionTopicData$8.title
                })
              })]
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
        align: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0px"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: size.width > 600 ? "div-gpt-ad-1701945220410-1" : "div-gpt-ad-1701946028239-1",
            style: {
              minWidth: "300px",
              minHeight: size.width > 600 ? "100px" : "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: size.width > 600 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})"
              }
            })
          })]
        }), " "]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
  });
};

/* harmony default export */ var KeyCandidatesD = (StateKeyCandidateD);
// EXTERNAL MODULE: ./src/pages/404.js
var _404 = __webpack_require__(7725);
;// CONCATENATED MODULE: ./src/pages/election/[electionState]/key-candidates/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var __N_SSP = true;
function Index(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: (props === null || props === void 0 ? void 0 : props.found) == false ? /*#__PURE__*/(0,jsx_runtime.jsx)(_404["default"], {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(KeyCandidatesD, _objectSpread({}, props))
  });
}

/***/ }),

/***/ 42287:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/election/[electionState]/key-candidates",
      function () {
        return __webpack_require__(5544);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,5613,532,2888,179], function() { return __webpack_exec__(42287); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);